<template>
    <div :data-component="$options.name">
        <cs-location-autocomplete
            :key="currentLocation"
            class="mb-16"
            label="PLZ oder Ort"
            :initialValue="currentLocation"
            :locationLevels="locationLevels"
            @select="onLocationSelected"
        />
        <cs-dropdown
            :modelValue="selectedRadius"
            class="text-text-l"
            label="Umkreis"
            :options="searchRadiusOptions"
            noEmptyOption
            @update:modelValue="onRadiusChanged"
        />
    </div>
</template>
<script lang="ts" src="./MsFilterLocationArea.ts" />
